(function (ws) {
    'use strict';
    ws.models.quoteTableData = Backbone.Model.extend({

        defaults: {},

        /**
         * Reset model to initial values
         */
        reset: function () {
            this.clear({
                silent: true
            });
            this.set(this.defaults);
        }
    });
})(westcon);
